module.exports = __webpack_public_path__ + "img/3.25b841d9.jpg";